<template>
	<div>
		<el-dialog
			:title="isEdit ? '编辑规划' : '新增规划'"
			:visible.sync="dialogVisible"
			width="40%"
			top="10vh"
			:close-on-click-modal="false"
			:before-close="handleClose"
			custom-class="plan-dialog">
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="资产编号" prop="assetId">
							<el-select
								v-model="form.assetId"
								placeholder="请选择资产编号"
								:disabled="isEdit"
								filterable
								remote
								reserve-keyword
								:remote-method="remoteMethod"
								:loading="loading"
								size="small"
								style="width: 100%"
								@change="handerChange">
								<el-option
									v-for="item in assetNoList"
									:key="item.id"
									:label="`${item.assetNo} ${item.assetName}`"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="规划类型" prop="planType">
							<el-select v-model="form.planType" placeholder="请选择规划类型" size="small" style="width: 100%">
								<el-option
									v-for="(item, index) in $menu.getList('PlanningType')"
									:key="index"
									:label="item.name"
									:value="item.value" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="规划目标" prop="planTarget">
							<el-input
								v-model="form.planTarget"
								type="textarea"
								size="small"
								placeholder="请明确规划要达成的目标，如年租金≥10万元，出租率100%" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始日期" prop="startDate">
							<el-date-picker
								v-model="form.startDate"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="请选择开始日期"
								style="width: 100%"
								size="small" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束日期" prop="endDate">
							<el-date-picker
								v-model="form.endDate"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="请选择结束日期"
								style="width: 100%"
								size="small" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="责任部门" prop="department">
							<el-select v-model="form.department" placeholder="请选择责任部门" size="small" style="width: 100%">
								<el-option v-for="item in OrgTree" :key="item.id" :label="item.text" :value="item.text" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="责任人" prop="responsiblePerson">
							<el-input v-model="form.responsiblePerson" size="small" placeholder="请填写责任人" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="联系电话" prop="contactPhone">
							<el-input v-model="form.contactPhone" size="small" placeholder="请填写联系电话" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="预算金额(元)" prop="budgetAmount">
							<el-input v-model="form.budgetAmount" size="small" placeholder="请输入预算金额" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="规划说明" prop="planDescription">
							<el-input
								v-model="form.planDescription"
								type="textarea"
								:rows="3"
								placeholder="请描述规划细节、实施步骤等" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="附件上传" prop="attachments">
							<FileUpload
								ref="upload"
								:limit="1"
								:accept="['jpg', 'png', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx']"
								title="上传规划方案、审批文件"
								v-model="fileList"
								@success="handleUploadSuccess">
								<template slot="tip">支持 jpeg/jpg、png、PDF、doc/docx、XLS/XLSX 格式</template>
							</FileUpload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 按钮 -->
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { listOrgTree } from '@/api/inspection/addMaintainancePlanApi.js';
	import { getCommunityId, getCommunityName } from '@/utils/vc.js';
	import { getAssetPage } from '@/api/asset/assetLedgerApi.js';
	import { getAssetPlanSave, getAssetPlanUpdate } from '@/api/asset/assetPlanApi.js';
	export default {
		name: 'AssetPlanDialog',
		props: {
			dialogVisible: Boolean,
			isEdit: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				loading: false,
				assetNoList: [],
				OrgTree: [],
				fileList: [],
				form: {
					assetId: '',
					assetName: '',
					assetNo: '',
					planType: '',
					planTarget: '',
					startDate: '',
					endDate: '',
					department: '',
					communityName: getCommunityName(),
					communityId: getCommunityId(),
					responsiblePerson: '',
					contactPhone: '',
					budgetAmount: '',
					planDescription: '',
					attachments: '',
				},
				rules: {
					assetId: [{ required: true, message: '请选择资产编号', trigger: 'change' }],
					planType: [{ required: true, message: '请选择规划类型', trigger: 'change' }],
					planTarget: [{ required: true, message: '请输入规划目标', trigger: 'blur' }],
					startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
					endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
					department: [{ required: true, message: '请选择责任部门', trigger: 'change' }],
					responsiblePerson: [{ required: true, message: '请输入责任人', trigger: 'blur' }],
					contactPhone: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' },
						{ pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' },
					],
				},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.getTreelist();
					this.remoteMethod();
					this.$nextTick(() => {
						if (this.isEdit) {
							Object.assign(this.form, this.data);
						} else {
							this.$refs.form && this.$refs.form.resetFields();
						}
					});
				} else {
					this.$refs.upload.reset();
				}
			},
		},
		methods: {
			async getTreelist() {
				const res = await listOrgTree();
				this.OrgTree = res.data.children || [];
			},
			async remoteMethod(query) {
				try {
					this.loading = true;
					const res = await getAssetPage({
						assetNo: query,
						communityId: getCommunityId(),
						pageNum: 1,
						pageSize: 999,
					});
					this.assetNoList = res.records || [];
				} catch (err) {
					console.log(err);
				} finally {
					this.loading = false;
				}
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(res, fileList) {
				this.form.attachments = fileList.map(item => item.response).join(',');
			},
			handerChange(val) {
				const item = this.assetNoList.find(e => e.id === val);
				if (item) {
					this.form.assetName = item.assetName;
					this.form.assetNo = item.assetNo;
				}
			},
			handleSubmit() {
				this.$refs.form.validate(valid => {
					console.log(this.form);

					if (!valid) return;
					console.log('数据', this.form);
					if (this.isEdit) {
						getAssetPlanUpdate(this.form)
							.then(res => {
								this.$message.success('编辑成功');
								this.$emit('updateSuccess');
							})
							.catch(err => {
								console.log(err);
								this.$message.error('编辑失败');
							});
					} else {
						getAssetPlanSave(this.form)
							.then(res => {
								this.$message.success('新增成功');
								this.$emit('updateSuccess');
							})
							.catch(err => {
								console.log(err);
								this.$message.error('新增失败');
							});
					}

					this.handleClose();
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
